import { t } from "i18next";
import * as yup from "yup";

export const stringValidation = yup.string().nullable();
export const numberValidation = yup.number().nullable();

export const getNumberValidationRequired = () =>
  yup
    .number()
    .required(() => t("validation.required"))
    .nullable();

export const getStringValidationRequired = () => {
  return yup
    .string()
    .required(() => t("validation.required"))
    .nullable();
};

export const getTrimmedStringValidationRequired = (max?: number) => {
  const schema = yup
    .string()
    .trim()
    .required(() => t("validation.required"))
    .min(1, () => t("validation.required"));

  return max
    ? schema.max(max, () => t("validation.maxLength", { max })).nullable()
    : schema.nullable();
};

export const dateValidation = yup
  .date()
  .nullable()
  .transform((value) => value.getFullYear().toString());

export const getPasswordValidationRequired = () =>
  yup
    .string()
    .required(() => t("validation.required"))
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&*])(?=.{8,})/, () =>
      t("validation.passwordContain"),
    );

export const getConfirmPasswordValidationRequired = () =>
  yup
    .string()
    .required(() => t("validation.required"))
    .oneOf([yup.ref("password")], () => t("validation.passwordMustMatch"));

export const getEmailValidationRequired = () =>
  yup
    .string()
    .email(() => t("validation.invalidEmail"))
    .required(() => t("validation.required"));

export const getPhoneValidationRequired = () =>
  yup
    .string()
    .required(() => t("validation.required"))
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, () =>
      t("validation.invalidPhoneNumber"),
    );

export const testAtLeastOneTrue = (
  yupThis: yup.TestContext<yup.AnyObject>,
  value: any,
  fieldsName: string[],
) => {
  const fields = fieldsName.map((field) => {
    return { data: value[field], name: `${yupThis.path}.${field}` };
  });

  const errors = fields
    .map((field) => {
      if (field.data) {
        return null;
      }

      return yupThis.createError({
        path: field.name,
        message: () => t("validation.required"),
      });
    })
    .filter(Boolean) as readonly yup.ValidationError[];

  if (errors.length < fields.length) {
    return true;
  }
  return new yup.ValidationError(errors);
};

export const testPhoneNumber = (
  yupThis: yup.TestContext<yup.AnyObject>,
  value: any,
  regionRegex: RegExp,
) => {
  if (!value.match(/^\+\d{2}\d{8,13}$/)) {
    return yupThis.createError({
      path: yupThis.path,
      message: () => t("validation.invalidPhoneNumber"),
    });
  }

  if (!value.match(regionRegex)) {
    return new yup.ValidationError([
      yupThis.createError({
        path: "registrationForm",
        message: () => t("validation.invalidPhoneRegion"),
      }),
      yupThis.createError({
        path: yupThis.path,
        message: " ",
      }),
    ]);
  }

  return true;
};
